import React, { useState } from 'react';
import './QuizEmailCapture.css';

const QuizEmailCapture = ({ 
  results, 
  quizType = 'ballet-variation',
  onComplete, 
  onClose 
}) => {
  const [email, setEmail] = useState('');
  const [subscribeNewsletter, setSubscribeNewsletter] = useState(true); // Pre-checked
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    // Check if we're in development mode
    const isDevelopment = window.location.hostname === 'localhost';
    
    if (isDevelopment) {
      // Simulate successful email sending in development
      console.log('Development mode - simulating email send');
      console.log('Email:', email);
      console.log('Subscribe to newsletter:', subscribeNewsletter);
      console.log('Quiz results:', results);
      
      // Simulate network delay
      setTimeout(() => {
        setIsLoading(false);
        onComplete(); // Close modal and show results
      }, 1500);
      return;
    }

    try {
      const response = await fetch('/api/quiz-results', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.trim(),
          quizType,
          results,
          subscribeNewsletter
        }),
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error('Failed to parse response as JSON:', jsonError);
        setError('Server error. Please try again or contact support.');
        return;
      }

      if (response.ok) {
        console.log('Quiz results sent successfully:', data);
        onComplete(); // Close modal and show results
      } else {
        setError(data.message || 'Failed to send results. Please try again.');
      }
    } catch (error) {
      console.error('Error sending quiz results:', error);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="quiz-email-capture-overlay">
      <div className="quiz-email-capture-modal">
        <div className="modal-header">
          <img 
            src="/prix_du_canada_main_logo.png" 
            alt="Prix du Canada" 
            className="modal-logo"
          />
          <h2>🔒 Your Results Are Ready!</h2>
        </div>

        {/* Results Preview Teaser */}
        <div className="results-preview-teaser">
          <p>✨ We've analyzed your 7 detailed responses and created personalized ballet variation recommendations just for you.</p>
        </div>

        <form onSubmit={handleSubmit} className="email-capture-form">
          <div className="form-group">
            <label htmlFor="email">📧 Enter your email to unlock your results:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              className="email-input"
              disabled={isLoading}
              required
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="newsletter-checkbox-group">
            <label className="newsletter-checkbox">
              <input
                type="checkbox"
                checked={subscribeNewsletter}
                onChange={(e) => setSubscribeNewsletter(e.target.checked)}
                disabled={isLoading}
              />
              <span className="checkmark"></span>
              Keep me updated on Prix du Canada registration and send me exclusive dance resources (includes $50 discount)
            </label>
          </div>

          <button 
            type="submit" 
            className="unlock-results-btn"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="loading-spinner"></span>
                Sending Results...
              </>
            ) : (
              '🔓 Get My Results'
            )}
          </button>

          <div className="warning-text">
            ⚠️ Without your email, these personalized recommendations will be lost forever when you close this page.
          </div>

          <button 
            type="button" 
            className="close-lose-btn"
            onClick={onClose}
            disabled={isLoading}
          >
            ❌ Close & Lose Results
          </button>
        </form>
      </div>
    </div>
  );
};

export default QuizEmailCapture;